import './_review-form-big.scss'
import galleryService from 'common/util/galleryService';
import ModalUtil from 'common/util/ModalUtil';

const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif']
const MAX_IMAGES_COUNT = 10;

export default () => Component(function ($context) {
    return $context.select('.review-form-big');
}, function ($form, self) {
    $.extend(self, {
        images: [],
        $uploadArea: $form.find('.review-form-big__upload-area'),
        $uploadItem: $($form.find('#upload-item').prop('content').cloneNode(true).firstElementChild),
        imageName: $form.find('.review-form-big__upload-input').data('name') || 'images',
        imageWithIndex: $form.find('.review-form-big__upload-input').data('with-index') || false,

        initEventListeners: function () {
            $form.find('.review-form-big__form').on('submit', function (e) {
                e.preventDefault();
                const formData = new FormData(this);

                self.images.forEach((file, index) => {
                    formData.append(`${self.imageName}${self.imageWithIndex ? `[${index}]` : ''}`, file)
                })

                $form.addClass('review-form-big_loading');

                $.ajax({
                    url: $(this).prop('action'),
                    type: 'POST',
                    data: formData,
                    cache: false,
                    contentType: false,
                    processData: false
                })
                    .then(self.handleAjaxSuccess)
                    .then(() => $form.removeClass('review-form-big_loading'));
            });

            $form.on('change', '.review-form-big__upload-input', function (e) {
                const imagesLength = self.images.length
                const maxCount = imagesLength ? MAX_IMAGES_COUNT - imagesLength : MAX_IMAGES_COUNT;
                let files = [...e.target.files];

                if (files.length > MAX_IMAGES_COUNT || maxCount === 0) {
                    window.infoPanel.show('Максимальное количество изображений: 10');
                }

                files = files.filter(file => {
                    if (self.images.find(image => image.name === file.name)) {
                        window.infoPanel.show('Изображения не должны повторяться');
                        return false;
                    }

                    if (!IMAGE_TYPES.includes(file.type)) {
                        window.infoPanel.show('Поддерживаемые форматы: .png, .jpeg, .gif');
                        return false;
                    }

                    return true;
                }).slice(0, maxCount);

                if (!files.length) {
                    return;
                }

                self.images = [...self.images, ...files];
                self.buildUploadItems(files);
            });

            galleryService.onListOpen('.review-form-big__upload-item',
                '.review-form-big__upload-area',
                '.review-form-big__upload-item-img',
                'src');

            $form.on('click', '.js-content-decorator a.link', function (e) {
                e.preventDefault();
                const $loginForm = $($('#index-modal-login-template').prop('content').firstElementChild.cloneNode(true));

                if (this.href.includes('signup')) {
                    $loginForm.find('.modal-login__tab[data-js-tab-target="login"]').removeClass('js-active');
                    $loginForm.find('.modal-login__tab[data-js-tab-target="reg"]').addClass('js-active');
                }

                ModalUtil.openContent($loginForm, function () {
                    Update($loginForm.parent());
                });
            })
        },

        buildUploadItems: function (files) {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const $uploadItem = self.$uploadItem.clone(true);
                const $image = $uploadItem.find('.review-form-big__upload-item-img');
                const reader = new FileReader();

                reader.onload = e => {
                    $image.prop('src', e.target.result);
                };

                reader.readAsDataURL(file);

                $uploadItem.find('.review-form-big__upload-item-name').html(file.name);
                $uploadItem.prop('title', file.name);
                $uploadItem.on('click', (e) => e.preventDefault())
                $uploadItem.find('.review-form-big__upload-item-close').on('click', self.closeUploadItem);

                self.$uploadArea.append($uploadItem)
            }
        },

        closeUploadItem: function (e) {
            const $item = $(e.target.closest('.review-form-big__upload-item'));
            $item.addClass('review-form-big__upload-item_removing');
            self.images.splice($item.index(), 1)
            setTimeout(() => {
                $item.remove()
            }, 300);
        },

        handleAjaxSuccess: function (response) {
            let status = response.status

            if (response.data && response.data.status) {
                status = response.data.status
            }

            if (status === 'ok') {
                let idResult = '#review-success'

                if (response.data && response.data.msg && response.data.msg.trim() === 'Отзыв отправлен на модерацию') {
                    idResult = '#review-moderate'
                }

                $form.find('.review-form-big__content').html(
                    $($form.find(idResult).prop('content').cloneNode(true).firstElementChild)
                );
            } else if (status === 'fail' || status === 'error') {
                const errors = response.errors || response.data && response.data.errors;

                if (!errors) {
                    window.infoPanel.show('Произошла неизвестная ошибка при попытке отправки формы');
                    return;
                }

                if (typeof errors === 'string') {
                    window.infoPanel.show(errors);
                    return;
                }

                if (!(errors instanceof Array)) {
                    if (errors.captcha_refresh) {
                        window.infoPanel.show('Капча введена неверно');
                    } else if (errors[0]) {
                        window.infoPanel.show(errors[0]);
                    } else if (errors instanceof Object) {
                        window.infoPanel.show(Object.values(errors).join(' '));
                        return;
                    }
                }

                window.infoPanel.show(errors.join(', '));
            }
        }
    });

    self.initEventListeners();
});